import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export const keys = createQueryKeySet<number>('competition_admins');

export function useCompetitionAdminListQuery(id: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.competitionsListCompetitionAdminsRetrieve(id);
      return data.competition_admins;
    },
    queryKey: keys.list(id),
  });
}
